'use strict';

const REGEX_SPLIT_NAME_NUMBER = /(\(\+\d{1,4}\))/;
const DROPDOWN_SELECT = '.dropdown_select_selected';
let isOpen = false;
let $actualContainer;

const restoreValueFromStorage = (path, $option, $container, pageName) => {
    const storage = Odigeo.Utils.parseJson(Odigeo.Session.storage[pageName]);
    const phoneCode = Odigeo._.get(storage, path);
    if (phoneCode) {
        $container.find($option).filter(`[data-value="${phoneCode}"]`).trigger(Odigeo.Events.tap);
    }
};

const storeInSession = (path, value, pageName) => {
    const storage = Odigeo.Utils.parseJson(Odigeo.Session.storage[pageName]);
    const data = Odigeo._.set(storage, path, value);
    Odigeo.Session.set(pageName, JSON.stringify(data));
};

const initDropdown = ($container, $option, path, pageName) => {
    attachEvents($container, $option, path, pageName);
    restoreValueFromStorage(path, $option, $container, pageName);
    formatText($container.find(DROPDOWN_SELECT), $container.find(DROPDOWN_SELECT));
};

const addEvent = (e) => {
    if (!$(e.target).hasClass('clickable_select')) {
        toggleDropdown($actualContainer);
    }
};

const toggleDropdown = ($container) => {
    $container.toggleClass('focus');
    isOpen = $container.hasClass('focus');
    if (isOpen || $container !== $actualContainer) {
        $('#page').on(Odigeo.Events.tap + '.dropdown', addEvent);
        $('#page .hint_trigger_button').on(Odigeo.Events.tap + '.dropdown', addEvent);
    } else {
        $('#page').off(Odigeo.Events.tap + '.dropdown');
        $('#page .hint_trigger_button').off(Odigeo.Events.tap + '.dropdown');
    }
    $actualContainer = $container;
};

const formatText = ($target, $dropdownSelected) => {
    const textWithoutName = $target.find('.select_text').text().match(REGEX_SPLIT_NAME_NUMBER) || [];
    $dropdownSelected.find('.select_text').html(textWithoutName[0]);
};

const selectOption = (event, $container, path, pageName) => {
    const $target = $(event.currentTarget);
    const $dropdownSelected = $container.find(DROPDOWN_SELECT);
    storeInSession(path, $target.data('value'), pageName);
    $dropdownSelected.html($target.html());
    formatText($target, $dropdownSelected);
};

const attachEvents = ($container, $option, path, pageName) => {
    $container.off().on(Odigeo.Events.tap, Odigeo._.bind(toggleDropdown, this, $container));
    $container.find($option).off().on(Odigeo.Events.tap, Odigeo._.bind(selectOption, this, _, $container, path, pageName));
};

module.exports = {
    initDropdown,
};
